<template lang="pug">
  SearchConditions(:initSearchCond="initSearchCond" @onChangeSearchConditions="onChangeSearchConditions")
    template(v-slot:conditions="{ conditions }")
      v-layout(wrap)
        v-flex(md2)
          v-text-field(label="権限名称" v-model="conditions.roleName")
</template>

<script>
import SearchConditions from "@/components/common/search/SearchConditions";

export default {
  components: {
    SearchConditions
  },
  methods: {
    onChangeSearchConditions(item) {
      this.$emit("onChangeSearchConditions", item);
    },
    initSearchCond() {
      return {
        conditions: {
          roleName: ""
        }
      };
    }
  }
};
</script>
